import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as recipeActions from "../../redux/actions/recipeActions";
import * as userActions from "../../redux/actions/userActions";
import { bindActionCreators } from "redux";
import HomePage from "./HomePage";

export function HomePageContainer({
  recipes,
  title,
  actions,
  reganAndRaeFavorites,
  recipeOptions,
  ...props
}) {
  useEffect(() => {
    actions.loadReganAndRaeFavorites();
  }, [props.title]);

  function handleSelect(id) {
    props.history.push(`/cookbook/recipe/${id}`);
  }

  function fetchRecipes(keyword) {
    if (!keyword || keyword === "all") {
      actions.loadRecipes();
    } else {
      actions.fetchRecipesByKeyword(keyword);
    }
  }
  return (
    <HomePage
      recipes={recipes}
      fetchRecipes={fetchRecipes}
      selectRecipe={handleSelect}
      title={title}
      reganAndRaeFavorites={reganAndRaeFavorites}
      recipeOptions={recipeOptions}
    />
  );
}

HomePageContainer.propTypes = {
  recipes: PropTypes.array.isRequired,
  actions: PropTypes.object,
  title: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  reganAndRaeFavorites: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    title: state.title || "",
    recipes: state.recipes.recipes.length ? state.recipes.recipes : [],
    recipeOptions: state.recipes.recipeOptions,
    reganAndRaeFavorites: state.reganAndRaeFavorites,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadRecipes: bindActionCreators(
        recipeActions.loadPublicRecipes,
        dispatch
      ),
      loadReganAndRaeFavorites: bindActionCreators(
        userActions.loadReganAndRaeFavorites,
        dispatch
      ),
      fetchRecipesByKeyword: bindActionCreators(
        recipeActions.fetchRecipesByKeyword,
        dispatch
      ),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
